import { intl } from "dmsbasereact";

export const NotDispensedReasonEnum = {
    RECEIVED_NUVYOR: "RECEIVED_NUVYOR",
    RECEIVED_OTHER_BRAND: "RECEIVED_OTHER_BRAND",
    DID_NOT_RECEIVE: "DID_NOT_RECEIVE",
    UNKNOWN: "UNKNOWN",
};

export const getNotDispensedReasonLabel = (value) => {
    const labels = {
        [NotDispensedReasonEnum.RECEIVED_NUVYOR]: intl.get("NotDispensedReason.ReceivedNuvyor").d("Received Nuvyor"),
        [NotDispensedReasonEnum.RECEIVED_OTHER_BRAND]: intl.get("NotDispensedReason.ReceivedOtherBrand").d("Received another brand"),
        [NotDispensedReasonEnum.DID_NOT_RECEIVE]: intl.get("NotDispensedReason.DidNotReceive").d("Did not receive"),
        [NotDispensedReasonEnum.UNKNOWN]: intl.get("NotDispensedReason.Unknown").d("I don't know"),
    };
    return labels[value] || value;
};

export const getNotDispensedReasonOptions = () =>
    Object.values(NotDispensedReasonEnum).map((value) => ({
        value,
        label: getNotDispensedReasonLabel(value),
    }));

/**
 * Formats a stored cancellation_justification value for display.
 * Handles format: "ENUM_VALUE" or "ENUM_VALUE | location text"
 */
export const formatNotDispensedJustification = (justification) => {
    if (!justification) return justification;
    const [enumPart, ...locationParts] = justification.split(' | ');
    const translatedLabel = getNotDispensedReasonLabel(enumPart);
    if (locationParts.length > 0) {
        return `${translatedLabel} | ${locationParts.join(' | ')}`;
    }
    return translatedLabel;
};
